import { Component, OnInit, Inject, EventEmitter } from '@angular/core';
import { MatDialogRef,  MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SystemService } from '../../../../../services/system.service';
import { ActionButtonEvent } from 'src/app/layout/action-button-toolbar/action-button-toolbar.component';
import { Observable, Subscription, of } from 'rxjs';
import { ColumnSetting } from 'src/app/layout/table-standard-layout/table-standard-layout.component';

@Component({
  selector: 'app-stock-filler-data-popup',
  templateUrl: './stock-filler-data-popup.component.html',
  styleUrls: ['./stock-filler-data-popup.component.css']
})
export class StockFillerDataPopupComponent implements OnInit {
 
  combObs$ = new Observable()
  rowActionButtons: { icon: string; tooltip: string; eventEmitter: EventEmitter<ActionButtonEvent>; }[];
  onShowUnit: EventEmitter<ActionButtonEvent>;
  onShowUnitSubscription: Subscription;
  columnSettings: ColumnSetting[] = [
    {
      columnId: 'productName',
      name: 'Name'
    },
    {
      columnId: 'productNumber',
      name: 'Number'
    },
    {
      columnId: 'machineName',
      name: 'Machine'
    },
    {
      columnId: 'selection',
      name: 'Selection'
    },{
      columnId: 'requiredQuantity',
      name: 'Required Quantity'
    },{
      columnId: 'availQuantity',
      name: 'Available Quantity'
    },
    ]
 
  sortArray = ['Name','Number','Machine','Selection','Required Quantity',"Available Quantity"]
  constructor(
    public dialogRef: MatDialogRef<StockFillerDataPopupComponent>,
    private systemService: SystemService,
    @Inject(MAT_DIALOG_DATA) public data) {
      console.log(data)
      this.combObs$ = of(data.data)
    }

  onNoClick(): void {
    this.dialogRef.close();
  }

  genEmail(id){
    this.systemService.genStockFillerMail(this.data.siteId,this.data.systemId,id)
    console.log(id)
  }
  ngOnInit() {
  }

}
